var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-schedule-2819785",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.538,
    height: 40.433,
    viewBox: "0 0 37.538 40.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2790",
    "data-name": "Groupe 2790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M11.859,2.988H25.586V.934A.96.96,0,0,1,26.613,0h3.548A1,1,0,0,1,31.1.934V2.988h2.428A4.027,4.027,0,0,1,37.538,6.91v29.6a4.027,4.027,0,0,1-4.015,3.922H4.015A3.966,3.966,0,0,1,0,36.511V6.91A3.966,3.966,0,0,1,4.015,2.988H6.443V.934A.936.936,0,0,1,7.377,0h3.548a.936.936,0,0,1,.934.934ZM25.586,4.856H11.859V6.817a.882.882,0,0,1-.934.934H7.377a.882.882,0,0,1-.934-.934V4.856H4.015A2.094,2.094,0,0,0,1.868,6.91V9.618h33.8V6.91a2.155,2.155,0,0,0-2.148-2.054H31.1V6.817a.96.96,0,0,1-1.027.934H26.52a.936.936,0,0,1-.934-.934Zm3.642-2.988H27.453V5.883h1.774Zm-19.236,0H8.311V5.883H9.992Zm25.679,9.618H1.868V36.511a2.094,2.094,0,0,0,2.148,2.054H33.523a2.155,2.155,0,0,0,2.148-2.054Z",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M104.9,163a9.852,9.852,0,0,1,0,19.7,9.852,9.852,0,1,1,0-19.7Zm0,1.868a7.984,7.984,0,1,0,7.937,7.937A7.931,7.931,0,0,0,104.9,164.868Z",
    transform: "translate(-86.129 -147.779)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M191,208.934a.936.936,0,0,1,.934-.934,1,1,0,0,1,.934.934v3.735h2.708a.936.936,0,0,1,.934.934.882.882,0,0,1-.934.934h-3.642A.882.882,0,0,1,191,213.6Z",
    transform: "translate(-173.165 -188.577)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a72908441b843305422fcf99f59f8a61.svg";
export { ForwardRef as ReactComponent };